/*
 * File: \src\service\data-rangers\src\config.js
 * Created Date: 2020-11-05 09:14:51
 * Author: gaozw
 * -----
 * Last Modified: 2020-11-05 11:51:12
 * Modified By: gaozw
*/
// jsSrc:"https://s3.pstatp.com/pgc/tech/collect/collect-rangers.js",
const serviceConfig={
    jsSrc: 'https://mapnew5.midea.com/dataFinder-sdk/web-sdk-v5.1.2.js',
    loadNumberMax:3
}

const initConfig = {
    app_id: 10000093,//  必须替换成申请的 app_id 10000039--生产 10000032--测试 10000093--资讯中心生产
    channel_domain: 'https://iotsdk.midea.com',  // 替换为私有部署部署服务地址
    log: false, // 开启调试日志
    disable_webid:true,
    disable_sdk_monitor:true,
    auto_profile:false
}

const paramsConfig={
    // evtParams: { // 设置共有的事件属性，具体见API
    //     username: 'lidh14',
    // },
    // common_params: 'hi', // 设置用户属性（公共属性）
    disable_auto_pv: true,
    channel: 'cn',
    autotrack: false,
    disable_sdk_monitor: true,
    user_unique_id:'meixin_demo_user'
}

export default {initConfig,paramsConfig,serviceConfig}
